import { IHashtag } from "@/models/IHashtag";

import { BaseRepository } from "@/repositories/BaseRepository";

class HashtagRepository extends BaseRepository<IHashtag> {
    constructor() {
        super("/");
    }

    public getHashtags(): Promise<IHashtag[]> {
        const path = "hashtags";

        return this.getAll({}, path);
    }
}

const hashtagRepository = new HashtagRepository();

export { HashtagRepository, hashtagRepository };
